var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-card',{staticClass:"dashboard-bar-chart",attrs:{"bordered":false}},[_c('chart-bar',{attrs:{"height":310,"data":_vm.barChartData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }